// extracted by mini-css-extract-plugin
module.exports = {"c-input":"input_c-input__r8YVF"};